module.exports = __webpack_public_path__ + "img/hgi-logo-truong-chinh-tri.dbc96dc7.png";